var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCentralDeAjuda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    d: "M17.423 9.1l-.024 8.711H8.712C3.908 17.811 0 13.903 0 9.1 0 4.297 3.908.389 8.712.389c4.803 0 8.711 3.908 8.711 8.711"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.986 12.884c0-.648-.53-1.172-1.183-1.172-.654 0-1.184.524-1.184 1.172 0 .648.53 1.172 1.184 1.172.654 0 1.183-.524 1.183-1.172M11.804 7.471c0-1.639-1.346-2.972-3.001-2.972-1.655 0-3.001 1.333-3.001 2.972h1.8c0-.655.539-1.189 1.2-1.189.663 0 1.201.534 1.201 1.189s-.538 1.189-1.2 1.189v.002a.897.897 0 0 0-.896.81h-.003v.044a.721.721 0 0 0 0 .075v.815a.896.896 0 0 0 .9.93.896.896 0 0 0 .894-.986v-.042a2.981 2.981 0 0 0 2.106-2.837"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralDeAjuda);
export default __webpack_public_path__ + "static/media/central-de-ajuda.0be1c539f7e5ab8e0ab3df18db90d03a.svg";
export { ForwardRef as ReactComponent };